import React, { useState } from "react";
import { Tabs } from "antd";
import PageHeader from "../../../Components/PageHeader";
import PendingApplicationsTab from "../../../Components/InstructorTabs/PendingApplicationsTab";
import ApprovedApplications from "../../../Components/InstructorTabs/ApprovedApplicationsTab";

const Applications = () => {

  const [key,setKey] = useState(1)

  const onChange = (key) => {
    setKey(key)
  };

  const items = [
    {
      key: "1",
      label: "Pending applications",
      children: <PendingApplicationsTab key={key}  />,
    },
    {
      key: "2",
      label: "Approved applications",
      children: <ApprovedApplications key={key}/>,
    },
  ];
  return (
    <div>
      <div className="d-flex gap-3 px-3">
        <div className="mt-5 pt-5 d-flex flex-column gap-4 w-100">
          <PageHeader title={"Instructor applications"} />
          <div className="p-3 bg-white">
            <p>LIST OF APPLICATIONS</p>
            <Tabs defaultActiveKey={key} items={items} onChange={onChange} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Applications;
